import { init } from '@rematch/core';
import { routerMiddleware } from 'react-router-redux';
import createLoadingPlugin from '@rematch/loading';
import selectPlugin, { getSelect } from '@rematch/select';
import createRematchPersist from '@rematch/persist';
import createCompressor from 'redux-persist-transform-compress';
import { reducer as toastr } from 'react-redux-toastr';

import * as models from './models';

import { history } from '../helpers';

const options = {}
const loading = createLoadingPlugin(options);
const compressor = createCompressor()
const persistPlugin = createRematchPersist({
  whitelist: ["app", "login"],
  throttle: 500,
  version: 1,
  transforms: [
    // createBlacklistFilter('app', ['helpContent'])
    compressor
  ]
});

export const store = init({
  models,
  plugins: [loading, persistPlugin, selectPlugin()],
  redux: {
    reducers: {
      toastr
    },
    middlewares: [routerMiddleware(history)]
  },
})